import { ItemToolbarConfiguration } from '@mirage-projects/cw-commons';

export const itemsToolbarMock: Array<ItemToolbarConfiguration> = [
    {
        id: 'fill',
        tooltip: 'FLOATING_TOOL_BAR.MAXIMIZE',
        icon: 'expand',
    },
    {
        id: 'split',
        tooltip: 'FLOATING_TOOL_BAR.SPLIT',
        icon: 'split-view',
    },
    {
        id: 'changeView',
        tooltip: 'VIEWS.3D',
        icon: '3d-view',
    },
    {
        id: 'resetExtent',
        tooltip: 'VIEW3D.RESET_EXTENT',
        icon: 'full-screen',
    },
    {
        id: 'toogleProjection',
        tooltip: 'VIEW3D.PROJECTION_VIEW',
        icon: '3d-perspective',
    },
    {
        id: 'orientation',
        tooltip: 'VIEW3D.SET_ORIENTATION',
        icon: '3d-orientation-overall',
    },
    {
        id: 'namedViews',
        tooltip: 'VIEW3D.SET_NAMED_VIEW',
        icon: 'eye-show',
    },
    {
        id: 'vr',
        tooltip: 'VIEW3D.ENTER_PANORAMA_MODE',
        icon: 'panorama',
    },
    {
        id: 'frontImage',
        tooltip: 'VIEW3D.IMAGE_IN_FRONT',
        icon: 'eye-show',
    },
    {
        id: 'previous',
        tooltip: 'VIEW3D.PREV_PANORAMA',
        icon: 'acc-left',
    },
    {
        id: 'next',
        tooltip: 'VIEW3D.NEXT_PANORAMA',
        icon: 'acc-right',
    },
    {
        id: 'inspectLocation',
        tooltip: 'FLOATING_TOOL_BAR.INSPECT_LOCATION',
        icon: 'search',
    },
    {
        id: 'multiSegment',
        tooltip: 'FLOATING_TOOL_BAR.PREVIOUS_SEGMENT',
        icon: 'acc-left',
    },
    {
        id: 'flip',
        tooltip: 'FLOATING_TOOL_BAR.FLIP_SECTION',
        icon: 'flip',
    },
    {
        id: 'scale',
        tooltip: 'FLOATING_TOOL_BAR.SCALE_SECTION',
        icon: 'invert',
    },
    {
        id: 'information',
        tooltip: 'TAB_TOOLS.INFORMATION',
        icon: 'pointer',
    },
    {
        id: 'measure',
        tooltip: 'TAB_TOOLS.DISTANCE',
        icon: 'draw-polygon',
    },
    {
        id: 'buffer',
        tooltip: 'TAB_TOOLS.BUFFER_TOOL',
        icon: 'draw-circle',
    },
    {
        id: 'annotation',
        tooltip: 'TAB_TOOLS.ANNOTATION',
        icon: 'edit-mode-add',
    },
    {
        id: 'layerEdition',
        tooltip: 'TAB_TOOLS.LAYER_EDITION',
        icon: 'draw',
    },
    {
        id: 'saveview',
        tooltip: 'TAB_TOOLS.SAVEVIEW',
        icon: 'viewpoint',
    },
    {
        id: 'screenshot',
        tooltip: 'TAB_TOOLS.SCREENSHOT',
        icon: 'photo-add',
    },
    {
        id: 'pointEdition',
        tooltip: 'TAB_TOOLS.POINT_EDITION_TOOL',
        icon: 'area',
    },
    {
        id: 'crViews',
        tooltip: 'VIEWS.3D',
        icon: '3d-isometric',
    },

    {
        id: 'drawingRule',
        tooltip: 'FLOATING_TOOL_BAR.LIDAR_PROPERTIES',
        icon: 'cloud-points',
    },
    {
        id: 'visibility',
        tooltip: 'PHOTOGRAMMETRY.TASK_ManageVisibility',
        icon: 'eye-show',
    },
    {
        id: 'vrPanorama',
        tooltip: 'FLOATING_TOOL_BAR.USE_GYROSCOPE',
        icon: 'manual',
    },
    {
        id: 'view_3D',
        tooltip: 'VIEWS.3D',
        icon: '3d-view',
    },
    {
        id: 'view_map',
        tooltip: 'VIEWS.MAP',
        icon: 'map',
    },
    {
        id: 'view_section',
        tooltip: 'VIEWS.SECTION',
        icon: 'section-view',
    },
    {
        id: 'view_table',
        tooltip: 'VIEWS.TABLE',
        icon: 'storage',
    },
    {
        id: 'view_gallery',
        tooltip: 'VIEWS.GALLERY',
        icon: 'image',
    },
    {
        id: '3dPerspective',
        tooltip: 'VIEW3D.SET_PERSPECTIVE',
        icon: '3d-perspective',
    },
    {
        id: 'ortho',
        tooltip: 'VIEW3D.SET_ORTHO',
        icon: '3d-orthographic',
    },
    {
        id: 'floormap',
        tooltip: 'VIEW3D.SET_FLOORMAP',
        icon: '3d-orientation-top',
    },
    {
        id: 'top_view',
        tooltip: 'VIEW3D.TOP_ORIENTATION',
        icon: '3d-orientation-top',
    },
    {
        id: 'bottom_view',
        tooltip: 'VIEW3D.BOTTOM_ORIENTATION',
        icon: '3d-orientation-bottom',
    },
    {
        id: 'front_view',
        tooltip: 'VIEW3D.FRONT_ORIENTATION',
        icon: '3d-orientation-front',
    },
    {
        id: 'back_view',
        tooltip: 'VIEW3D.BACK_ORIENTATION',
        icon: '3d-orientation-back',
    },
    {
        id: 'left_view',
        tooltip: 'VIEW3D.LEFT_ORIENTATION',
        icon: '3d-orientation-left',
    },
    {
        id: 'right_view',
        tooltip: 'VIEW3D.RIGHT_ORIENTATION',
        icon: '3d-orientation-right',
    },
    {
        id: 'isometric_view',
        tooltip: 'VIEW3D.ISO_ORIENTATION',
        icon: '3d-isometric',
        onlyOrtho: true,
    },
    {
        id: 'tools',
        tooltip: 'TAB_TOOLS.TOOLS_TITLE',
        icon: 'management',
    },
];
